import { Stack } from '@mui/material';
import { ITogglePanel } from '@pages/NewQuote/TogglePanel';
import { PanelBase, PanelBaseType } from '@pages/NewQuote/PanelBase/PanelBase';
import { useNewQuoteStore } from '@store/NewQuote';
import { fakeLocalMidnightFromTZMidnight } from '@utils/date';
import { Field } from '@pages/NewQuote/scope/Field';
import { QuoteSetupPresetGetResponse } from '@lio/api-types';

interface IScopeClosedPanel extends ITogglePanel {
  quotePreset?: QuoteSetupPresetGetResponse;
}

export const ScopeClosedPanel = (props: IScopeClosedPanel) => {
  const { onOpen, quotePreset } = props;
  const { scope } = useNewQuoteStore();
  const {
    brokerageAgency,
    brokerageProducer,
    productOption,
    productOffering,
    effectiveDate,
    expirationDate,
    isSpecialEvent,
  } = scope;

  return (
    <PanelBase name='Scope' type={PanelBaseType.Closed} onEdit={onOpen}>
      <Stack direction='column' spacing='8px'>
        {!quotePreset && (brokerageAgency?.label || brokerageProducer?.label) && (
          <Stack direction='row' spacing='10px'>
            {brokerageAgency?.label && <Field value='Brokerage' label={brokerageAgency.label} />}
            {brokerageProducer?.label && <Field value='Producer' label={brokerageProducer.label} />}
          </Stack>
        )}
        {(productOffering?.value || productOption?.name) && (
          <>
            <Stack direction='column' spacing='10px'>
              {productOffering?.value && <Field value='Product' label={productOffering.label} />}
              {productOption?.name && <Field value='Business Class' label={productOption.name} />}
            </Stack>
          </>
        )}
        {isSpecialEvent ? (
          <>
            {effectiveDate && (
              <Stack>
                <Field
                  value='Event Start Date'
                  label={fakeLocalMidnightFromTZMidnight(effectiveDate).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                  })}
                />
              </Stack>
            )}
            {expirationDate && (
              <Stack>
                <Field
                  value='Event End Date'
                  label={fakeLocalMidnightFromTZMidnight(expirationDate).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                  })}
                />
              </Stack>
            )}
          </>
        ) : (
          <>
            {effectiveDate && (
              <Stack>
                <Field
                  value='Effective Date'
                  label={fakeLocalMidnightFromTZMidnight(effectiveDate).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                  })}
                />
              </Stack>
            )}
          </>
        )}
      </Stack>
    </PanelBase>
  );
};
